import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntradaAppRoutingModule } from './entrada.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EntradaAppRoutingModule
  ]
})
export class EntradaAppModule { }
